import React from "react";

const TwoButtons = ({ input: { onChange, value }, options = [] }) => (
  <span className="isolate inline-flex rounded-md shadow-sm">
    {options.map(({ value: buttonValue, label }, offset) => {
      const classes = `${
        offset === 0 ? "rounded-l-md" : "rounded-r-md -ml-px"
      } ${
        value === buttonValue
          ? "bg-gray-600 text-white hover:bg-gray-700"
          : "bg-white text-gray-700 hover:bg-gray-50"
      } cursor-pointer relative inline-flex items-center border border-gray-300 px-8 py-3 text-base font-medium focus:z-10 focus:border-gray-500 focus:outline-none focus:ring-1 focus:ring-gray-500`;

      return (
        <a
          tabIndex={0}
          key={buttonValue}
          className={classes}
          onClick={() => {
            onChange(buttonValue);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              e.stopPropagation();
              onChange(buttonValue);
            }
            if (e.key === "Escape") {
              onChange(null);
            }
          }}
        >
          {label}
        </a>
      );
    })}
  </span>
);

export default TwoButtons;
